import { RestApiRequest } from "../Models/RestApiRequest";
import { RestApiResponse } from "../Models/RestApiResponse";

export const baseURL = process.env.REACT_APP_DEALERS_API;

export const fetchData = async (
  request: RestApiRequest
): Promise<RestApiResponse> => {
  var objResponse: RestApiResponse = { success: false };
  try {
    var response = await fetch(`${baseURL}${request.url}`, {
      method: request.method,
      credentials: "include",
      body: JSON.stringify(request.body),
      headers: request.headers,
    });

    if (response.status === 401) {
      return { statusCode: 401, success: false };
    }

    if (!response.ok) {
      objResponse.success = false;
      const responseText = await response.text();

      try {
        const data = JSON.parse(responseText);

        objResponse.errorCode = data.ErrorCode ? data.ErrorCode : "";
      } catch (error) {
        console.log("Error while parsing response body: " + error);
        objResponse.success = false;
      }
    } else {
      objResponse.success = true;
      try {
        const responseString = await response.text();
        const data = responseString === "" ? {} : JSON.parse(responseString);

        objResponse.data = data;
      } catch (error) {
        console.log("Error while parsing response body: " + error);
        objResponse.success = false;
      }
    }
  } catch (error) {
    objResponse.success = false;
    objResponse.errorCode = "UnknownError";
  }

  return await objResponse;
};
